export default __webpack_public_path__ + "static/media/Aircraft3-t.7623a896.png";